import {
	Component,
	EventEmitter,
	HostListener,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	TemplateRef,
} from '@angular/core';
import { ButtonStyle } from '@componentes/button/button.component';

export type CardButtonStyle = ButtonStyle;

export interface CardButton {
	label: string;
	icon?: string;
	link?: string;
	action?: () => void;
	loading?: boolean;
	loadingLabel?: string;
	disabled?: boolean;
	buttonStyle?: CardButtonStyle;
}

@Component({
	selector: 'seira-card',
	templateUrl: './card.component.html',
	styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit, OnChanges {
	@Input() cardHeaderBackgroud = '';
	@Input() iconHeader = '';
	@Input() textHeader = '';
	@Input() footerContent?: TemplateRef<void>;
	@Input() bodyClass?: string = '';
	@Input() hasButton?: boolean = false;
	@Input() buttonLabel?: string = '';
	@Input() buttonLink?: string = '';
	@Input() buttonIcon?: string = '';
	@Input() hasSecondaryButton = false;
	@Input() secondaryButtonLabel = '';
	@Input() secondaryButtonLink = '';
	@Input() secondaryButtonIcon = '';
	@Input() inverterBotoes = false;
	@Input() buttons: CardButton[] = [];
	isSmallScreen = false;
	resolutionSmall = 730;
	@Output() secondaryButtonAction = new EventEmitter();
	@Output() buttonAction = new EventEmitter();
	@Input() isLoadingSecondaryButton = false;
	@Input() secondaryButtonLoadingLabel?: string;
	mappedButtonStyle: CardButtonStyle = 'cancel';
	mappedSecondaryButtonStyle: CardButtonStyle = 'cancel';

	constructor() {
		const ehValido =
			!this.hasSecondaryButton ||
			(this.hasSecondaryButton &&
				(this.secondaryButtonAction ||
					this.secondaryButtonLabel ||
					this.secondaryButtonIcon ||
					this.secondaryButtonLink ||
					this.secondaryButtonLoadingLabel));
		if (!ehValido) {
			throw Error(
				'É preciso setar hasSecondaryButton pra true para setar as propriedades do segundo botão'
			);
		}
	}

	buttonStyle: CardButtonStyle = 'cancel';

	ngOnInit(): void {
		this.checkScreenSize();
		this.updateLegacyButtonStyles();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['buttonIcon'] || changes['secondaryButtonIcon']) {
			this.updateLegacyButtonStyles();
		}
	}

	private getMappedGeneralButtonStyle(icon?: string): CardButtonStyle {
		let style: CardButtonStyle = 'cancel';
		switch (icon) {
			case 'add':
				style = 'add';
				break;
			case 'edit':
				style = 'edit';
				break;
			case 'remove':
				style = 'remove';
				break;

			case 'view':
				style = 'view';
				break;

			case 'cancel':
				style = 'cancel';
				break;

			case 'save':
				style = 'save';
				break;

			case 'limpar':
				style = 'limpar';
				break;

			case 'alterar':
				style = 'alterar';
				break;

			case 'importar':
				style = 'importar';
				break;

			case 'list':
				style = 'list';
				break;

			case 'atualizar':
				style = 'atualizar';
				break;

			case 'sincronizar':
				style = 'sincronizar';
				break;

			case 'download':
				style = 'download';
				break;

			case '':
				style = 'alterar';
				break;
		}
		return style;
	}

	private updateLegacyButtonStyles(): void {
		this.mappedButtonStyle = this.getMappedGeneralButtonStyle(this.buttonIcon);
		this.mappedSecondaryButtonStyle = this.getMappedGeneralButtonStyle(
			this.secondaryButtonIcon
		);
	}

	@HostListener('window:resize')
	onResize(): void {
		this.checkScreenSize();
	}

	private checkScreenSize(): void {
		this.isSmallScreen = window.innerWidth <= this.resolutionSmall;
	}

	_secondaryButtonAction() {
		this.secondaryButtonAction.emit();
	}
	_buttonAction() {
		this.buttonAction.emit();
	}

	_cardButtonAction(button: CardButton) {
		button.action?.();
	}
}
